define( 'auth-media-gateway/vo/MediaCatalogResponseVO',['require','exports','module','auth-media-gateway/subclasses/MediaFrameworkResponseHelper'],function( require, exports, module ) {

    var MediaFrameworkResponseHelper = require('auth-media-gateway/subclasses/MediaFrameworkResponseHelper');
    var _ensureArray = function(obj) {
        return (obj instanceof Array) ? obj : (typeof obj !== 'undefined') ? [obj] : [];
    };

    function MediaCatalogResponseVO(mediaResponse, profile){
        var isAuthorized,
            isLoginRequired,
            isAllVideoBlackedOut,
            videoBlackoutStatus,
            isAllContentBlackedOut,
            allContentBlackoutStatus,
            retVal,
            i;

        var calendarEventId = mediaResponse.user_verified_event.event_id;

        var mfResponseHelper = new MediaFrameworkResponseHelper(mediaResponse);
        isAuthorized = mfResponseHelper.isAuthorized();
        isLoginRequired = mfResponseHelper.isLoginRequired();

        videoBlackoutStatus = mfResponseHelper.getBlackoutStatus();
        isAllVideoBlackedOut = mfResponseHelper.isVideoBlackedOut(videoBlackoutStatus);

        allContentBlackoutStatus = mfResponseHelper.getBlackoutStatus(true);
        isAllContentBlackedOut = mfResponseHelper.isVideoBlackedOut(allContentBlackoutStatus);

        var contentItems = _ensureArray(mediaResponse.user_verified_event.user_verified_content);

        if (!!contentItems && contentItems.length>0) {
            var tmpContentItem,
                media_item;

            for (i in contentItems) {
                tmpContentItem = contentItems[i];
                if ( !!tmpContentItem ) {
                    tmpContentItem.domainAttributes = MediaFrameworkResponseHelper.getDomainAttributesObject(tmpContentItem);
                }
            }
        }


        //return an object with useful values at the top level
        this.calendarEventId = calendarEventId;
        this.isAuthorized = isAuthorized;
        this.isLoginRequired = isLoginRequired;
        this.isNotBlackedOut = !isAllVideoBlackedOut;
        this.videoBlackoutStatus = videoBlackoutStatus;
        this.isAllContentNotBlackedOut = !isAllContentBlackedOut;
        this.allContentBlackoutStatus = videoBlackoutStatus;
        this.mediaServiceVO = mediaResponse;
        this.profile = profile;
    }

    return MediaCatalogResponseVO;
});

